import { useLocalStorageState } from '@components/component-helpers';

import { useKeyboardSecret } from './use-keyboard-secret';

type useKeyboardSecretToggleProps = {
  shortcut: string;
  defaultValue?: boolean;
  key: string;
  onSuccess?: (value: boolean) => void;
};

export const useKeyboardSecretToggle = ({
  shortcut,
  defaultValue = false,
  key,
  onSuccess,
}: useKeyboardSecretToggleProps) => {
  const [value, setValue] = useLocalStorageState({
    key,
    defaultValue,
  });

  useKeyboardSecret({
    shortcut,
    onSuccess: () => {
      setValue(!value);
      if (onSuccess) {
        onSuccess(value);
      }
    },
  });

  return value;
};
